// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wX9V","colMin":"styles_colMin__3KhES"};